import { checkAuth } from '../../../actions/integration/methods/check-auth'
import { checkAuth as checkGoogleAuth } from '../../../actions/google/methods/check-auth'
import { useAssetStore } from '@/stores/asset'

/**
 * Checks connection status for all integrations
 * @param {Array} integrations - Array of integration objects to update
 * @returns {Promise<void>} Does not return a value, updates integrations directly
 */
export const checkAllIntegrations = async (integrations) => {
  const assetStore = useAssetStore()
  
  try {
    // Standard check for non-Google integrations
    const response = await checkAuth(assetStore.assetId)

    // Process response for non-Google integrations
    if (response) {
      const connectedPlatforms = Array.isArray(response) ? response : []

      // Update each non-Google integration's connected status
      integrations.forEach(integration => {
        if (integration.id !== 6) { // Skip Google integration
          if (connectedPlatforms.length > 0) {
            const foundPlatform = connectedPlatforms.find(platform => 
              platform && (platform.platformId === integration.id || platform.id === integration.id)
            )
            integration.connected = !!foundPlatform
          } else {
            integration.connected = false
          }
        }
      })
    }

    // Special check for Google integration
    try {
      const googleResponse = await checkGoogleAuth(assetStore.assetId)
      const googleIntegration = integrations.find(i => i.id === 6)
      
      if (googleIntegration && googleResponse) {
        googleIntegration.connected = googleResponse.isConnected
      }
    } catch (googleError) {
      const googleIntegration = integrations.find(i => i.id === 6)
      if (googleIntegration) {
        googleIntegration.connected = false
      }
    }
  } catch (error) {
    // On general error, mark all as disconnected
    integrations.forEach(integration => {
      integration.connected = false
    })
  }
}
